import React from 'react';
import PropTypes from 'prop-types';
import styles from './TraderDashboard.module.css';

const ResultsSection = ({ 
  isRunning, 
  isCompleted, 
  jobStatus, 
  progress, 
  results, 
  formatValue 
}) => {
  if (isRunning) {
    return (
      <div className={styles.statusSection}>
        <p>Status: <strong>{jobStatus}</strong></p>
        <div className={styles.progressBar}>
          <div className={styles.progressFill} style={{ width: `${progress}%` }} />
        </div>
        <p className={styles.progressText}>{progress.toFixed(0)}% Complete</p>
      </div>
    );
  }

  if (isCompleted && results?.metrics) {
    return (
      <div className={styles.metricsGrid}>
        <div className={styles.metricItem}>
          <p className={styles.metricTitle}>Total Return</p>
          <p className={styles.metricValue}>{formatValue(results.metrics.total_return, true)}</p>
        </div>
        <div className={styles.metricItem}>
          <p className={styles.metricTitle}>Sharpe Ratio</p>
          <p className={styles.metricValue}>{formatValue(results.metrics.sharpe_ratio)}</p>
        </div>
        <div className={styles.metricItem}>
          <p className={styles.metricTitle}>Max Drawdown</p>
          <p className={styles.metricValue}>{formatValue(results.metrics.max_drawdown, true)}</p>
        </div>
      </div>
    );
  }

  return null;
};

ResultsSection.propTypes = {
  isRunning: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  jobStatus: PropTypes.string,
  progress: PropTypes.number,
  results: PropTypes.shape({
    metrics: PropTypes.shape({
      total_return: PropTypes.number,
      sharpe_ratio: PropTypes.number,
      max_drawdown: PropTypes.number,
    }),
  }),
  formatValue: PropTypes.func.isRequired,
};

export default ResultsSection;